import { User } from "../../core/auth";
import { storeBuilder } from "../RootState";

// Local Storage Key to store the user
const LS_USER_KEY = "roon-user";

export class AuthState {
  currentUser: User | null = null;
}

const b = storeBuilder.module<AuthState>("auth", new AuthState());

// getters
const currentUser = b.read((state) => state.currentUser, "currentUser");
const isAuthenticated = b.read(
  (state) => !!state.currentUser,
  "isAuthenticated"
);

export const getters = {
  get currentUser() {
    return currentUser();
  },
  get isAuthenticated() {
    return isAuthenticated();
  },
};

// mutations
function setUser(state: AuthState, user: User) {
  state.currentUser = user;

  try {
    localStorage.setItem(LS_USER_KEY, JSON.stringify(user));
  } catch (err) {
    console.warn(err);
  }
}

function clearUser(state: AuthState) {
  state.currentUser = null;

  try {
    localStorage.removeItem(LS_USER_KEY);
  } catch (err) {
    console.warn(err);
  }
}

function loadUserFromLS(state: AuthState) {
  try {
    const user = localStorage.getItem(LS_USER_KEY);
    if (!user) {
      return;
    }

    const parsedUser = JSON.parse(user);

    state.currentUser = parsedUser as User;
  } catch (err) {
    console.warn(err);
  }
}

export const mutations = {
  setUser: b.commit(setUser),
  clearUser: b.commit(clearUser),
  loadUserFromLS: b.commit(loadUserFromLS),
};
